import { createElement } from "react";
import type { AppRoute } from "@routes/types";
import AppShellLayout from "@components/ui/layout/AppShellLayout";
import type { RouteObject } from "react-router-dom";
import { OFFER_CREATE_PATH, OFFER_PUBLIC_LIST_PATH } from "@routes/path";
import CreateOfferPage from "@pages/offer/create";
import OfferList from "@pages/offer/list";

const routes: AppRoute[] = [
    {
        path: OFFER_CREATE_PATH,
        element: createElement(CreateOfferPage),
        label: "New Offer",
    },
];

const publicRoutes: AppRoute[] = [
    {
        path: OFFER_PUBLIC_LIST_PATH,
        element: createElement(OfferList),
        label: "Public Offers",
    },
];

const OfferRoute: RouteObject[] = [{
                element: createElement(AppShellLayout),
                children: routes
            }];

export const OfferPublicRoute: RouteObject[] = [{
    element: createElement(AppShellLayout),
    children: publicRoutes
}];

export default OfferRoute;